import React, { useState, useEffect, useRef, useContext } from "react";
import { Paginator } from "primereact/paginator";
import {
  getIncentiveList,
  postIncentiveAddUpdate,
  postIncentiveDelete,
} from "./Services/PayrollService";
import * as Yup from "yup";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { TostMsg } from "../../../App";

// All icons are now inline SVGs (no react-icons needed)
const IncentiveManagement = () => {
  const [incentiveManagementSummery, setIncentiveManagementSummery] = useState(
    [],
  );
  const [incentiveManagementList, SetIncentiveManagementList] = useState([]);
  const [incentiveStatusList, SetIncentiveStatusList] = useState([]);
  const [incentiveTypesList, SetIncentiveTypesList] = useState([]);
  const [EmployeeList, setEmployeeList] = useState([]);
  const [formonthList, setFormonthList] = useState([]);
  const [arrears, setArrears] = useState([]);
  const [incentives, setIncentives] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const searchTimeout = useRef(null);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toaster = useContext(TostMsg);

  // Form State
  const [formData, setFormData] = useState({
    EmployeeName: "",
    IncentiveTypeName: "",
    amount: "",
    PaidAmount: "",
    Description: "",
    ForPeriod: "",
    IncentiveStatusName: "Open",
    TaxTreatment: "Taxable",
    Notes: "",
  });

  const [formErrors, setFormErrors] = useState({});

  // Yup Validation Schema
  const incentiveValidationSchema = Yup.object().shape({
    EmployeeName: Yup.string().required("Employee is required"),
    IncentiveTypeName: Yup.string().required("Incentive Type is required"),
    amount: Yup.number()
      .typeError("Amount must be a number")
      .required("Amount is required")
      .positive("Amount must be positive"),
    PaidAmount: Yup.string(),
    Description: Yup.string(),
    ForPeriod: Yup.string(),
    IncentiveStatusName: Yup.string().required("Status is required"),
    TaxTreatment: Yup.string().required("Tax Treatment is required"),
    Notes: Yup.string(),
  });

  useEffect(() => {
    getMasterData();
    GetEmployeeList();
  }, []);

  const GetEmployeeList = async () => {
    let params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EpmId,
      IsDirectReportOrHierarchy: 0,
      EmployeeId: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsSuggestedOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
    };
    try {
      let res = await getEmployeeList(params);
      console.log(res.Data);
      setEmployeeList(res.Data);
    } catch (error) {
      console.error("Error fetching employee list:", error);
    }
  };

  const getMasterData = async () => {
    try {
      // setIsloading(true);

      const statusParams = {
        masterType: "IncentiveStatus",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };

      const typeParams = {
        masterType: "IncentiveTypes",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };

      const formonthParams = {
        masterType: "formonth",
        allRecords: true,
        organisationId: userDetails?.OrgId,
      };

      const [statusRes, typeResm, formonthRes] = await Promise.all([
        GetMasterTypeData(statusParams),
        GetMasterTypeData(typeParams),
        GetMasterTypeData(formonthParams),
      ]);

      SetIncentiveStatusList(statusRes?.Data || []);
      SetIncentiveTypesList(typeResm?.Data || []);
      setFormonthList(formonthRes?.Data || []);
    } catch (error) {
      // toster.current.error(ERROR_LIST?.MasterDataType);
    } finally {
      // setIsloading(false);
    }
  };

  const GetIncentiveList = async (page = 1, size = rows) => {
    // const typeData = incentiveTypesList?.find(t => t.Name === filterType);
    // const statusData = incentiveStatusList?.find(s => s.Name === filterStatus);

    let params = {
      IncentiveId: 0,
      OrgId: userDetails?.OrgId,
      GUID: "",
      EmpId: 0,
      PageNumber: page,
      PageSize: size,
      Search: searchQuery || "",
      IncentiveStatusId: filterStatus || "",
      IncentiveTypeId: filterType || "",
      LoggedInEmpId: 0,
    };
    try {
      let res = await getIncentiveList(params);
      setIncentiveManagementSummery(res?.Data?.IncentiveDashboardDetails[0]);
      setIncentives(res?.Data?.IncentiveResponseDetails || []);
      setTotalRecords(
        res?.Data?.RecordCount ||
          res?.Data?.TotalRecords ||
          res?.Data?.TotalCount ||
          res?.Data?.IncentiveResponseDetails?.length ||
          0,
      );
    } catch (error) {
      console.error("Error fetching incentive list:", error);
    }
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    const page = event.first / event.rows + 1;
    GetIncentiveList(page, event.rows);
  };

  const PostIncentiveAddUpdate = async (params) => {
    try {
      console.log("Sending incentive params:", params);
      let res = await postIncentiveAddUpdate(params);
      console.log("Incentive API Response:", res);
      if (res?.StatusCode === 2000) {
        toaster.current.success(`Incentive ${params.Id ? "updated" : "added"} successfully`);
        GetIncentiveList(1, rows);
        setFirst(0);
        closeModal();
        return { success: true };
      } else {
        toaster.current.error(res?.Message || "Error saving incentive");
        console.error("API Error:", res?.Message || "Unknown error");
        return {
          success: false,
          error: res?.Message || "Error saving incentive. Please try again.",
        };
      }
    } catch (error) {
      console.error("Error saving incentive:", error);
      toaster.current.error("Error saving incentive");
      return {
        success: false,
        error: error.message || "Error saving incentive",
      };
    }
  };

  const [nextId, setNextId] = useState(6);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterStatus, setFilterStatus] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      GetIncentiveList(1, rows);
      setFirst(0);
    }, 500);
    return () => clearTimeout(searchTimeout.current);
  }, [searchQuery, filterType, filterStatus]);

  const clearFieldError = (fieldName) => {
    setFormErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[fieldName];
      return newErrors;
    });
  };

  const rup = (n) => (n ? `₹${n.toLocaleString("en-IN")}` : "—");

  // Server-side filtering — incentives already contains the filtered page
  const pageTotalAmount = incentives.reduce((a, v) => a + (v.Amount || 0), 0);

  const openAdd = () => {
    setEditId(null);
    setFormData({
      EmployeeName: "",
      IncentiveTypeName: "",
      amount: "",
      PaidAmount: "",
      Description: "",
      ForPeriod: "",
      IncentiveStatusName: "Open",
      TaxTreatment: "Taxable",
      Notes: "",
    });
    setFormErrors({});
    setShowModal(true);
  };

  const openEdit = (Id) => {
    const record = incentives.find((v) => v.Id === Id);
    if (!record) return;

    setEditId(Id);
    setFormData({
      EmployeeName: `${record.EmployeeName}|${record.EmpId}`,
      IncentiveTypeName: record.IncentiveTypeName,
      amount: record.Amount.toString(),
      PaidAmount: record.PaidAmount || "",
      Notes: record.Notes || "",
      IncentiveStatusName: record.IncentiveStatusName,
      TaxTreatment: record.TaxTreatment,
      Description: record.Description || "",
      ForPeriod: record.ForPeriod || "",
    });
    setFormErrors({});
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const saveIncentive = async () => {
    try {
      // Clear previous errors
      setFormErrors({});

      // Validate form data
      await incentiveValidationSchema.validate(formData, { abortEarly: false });

      const {
        EmployeeName,
        IncentiveTypeName,
        amount,
        PaidAmount,
        Notes,
        ForPeriod,
        IncentiveStatusName,
        TaxTreatment,
        Description,
      } = formData;
      const Amount = parseFloat(amount) || 0;

      // Parse employee IDs
      const [empName, empId] = EmployeeName.includes("|")
        ? EmployeeName.split("|")
        : [EmployeeName, ""];

      // Find the type ID from incentiveTypesList
      const typeData = incentiveTypesList?.find(
        (t) => t.Name === IncentiveTypeName,
      );
      const typeId = typeData?.Id || 0;

      // Find the status ID from incentiveStatusList
      const statusData = incentiveStatusList?.find(
        (s) => s.Name === IncentiveStatusName,
      );
      const statusId = statusData?.Id || 0;

      // Find the employee data
      const employeeData = EmployeeList?.find((e) => e.EmploymentId === empId);
      const empEmpId = employeeData?.EmpId || 0;

      // Prepare params for API
      let params = {
        Id: editId || 0,
        OrgId: userDetails?.OrgId || 0,
        EmpId: empEmpId,
        IncentiveTypeId: typeId,
        Amount: Amount,
        PaidAmount: PaidAmount ? parseFloat(PaidAmount) : 0,
        ForPeriod: ForPeriod || "",
        Description: Description || "",
        TaxTreatment: TaxTreatment,
        IncentiveStatusId: statusId,
        Notes: Notes || "",
      };

      // Call API
      const result = await PostIncentiveAddUpdate(params);

      if (!result.success) {
        setFormErrors({ form: result.error });
      }
    } catch (error) {
      if (error.inner) {
        // Yup validation error with multiple errors
        const errors = {};
        error.inner.forEach((err) => {
          errors[err.path] = err.message;
        });
        setFormErrors(errors);
      } else if (error.name === "ValidationError") {
        setFormErrors({ form: error.message });
      } else {
        console.error("Error saving incentive:", error);
        setFormErrors({
          form: "Error saving incentive. Please check the console.",
        });
      }
    }
  };

  const askDelete = (Id) => {
    setDeleteId(Id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async() => {
    // setIncentives((prev) => prev.filter((v) => v.Id !== deleteId));
    // setShowDeleteModal(false);

     try {
    
      const params = {
        RequestId:deleteId
      };

      const result = await postIncentiveDelete(params);
      if (result.success) {
        toaster.current.success("Incentive deleted successfully");
        setShowDeleteModal(false);
        setDeleteId(null);
        await GetIncentiveList();
      } else {
        toaster.current.error(result.error || "Error deleting incentive");
      }
    } catch (error) {
      console.error("Error deleting incentive:", error);
      toaster.current.error("Error deleting incentive");

    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    clearFieldError(name);
  };

  // ====================== INLINE SVG ICONS ======================
  const IconGauge = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M8 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12zM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0z" />
      <path d="M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8z" />
    </svg>
  );

  const IconUsers = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
      <path d="M2 13a6 6 0 0 1 12 0v1H2v-1z" />
    </svg>
  );

  const IconCalendar = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5z" />
      <path d="M11 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z" />
    </svg>
  );

  const IconClock = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1 0-1H7.5V4a.5.5 0 0 1 .5-.5z" />
      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
    </svg>
  );

  const IconMoney = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M8 1a7 7 0 1 1 0 14 7 7 0 0 1 0-14z" />
      <path d="M8 3.5a.5.5 0 0 1 .5.5v.5h1a.5.5 0 0 1 0 1H8.5v1a.5.5 0 0 1-1 0V6H7a.5.5 0 0 1 0-1h1V4a.5.5 0 0 1 .5-.5z" />
    </svg>
  );

  const IconInvoice = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M4 1h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2z" />
      <path d="M4 4h8v1H4V4zm0 3h8v1H4V7zm0 3h5v1H4v-1z" />
    </svg>
  );

  const IconSliders = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M8 2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h6z" />
      <path d="M14 8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h8z" />
    </svg>
  );

  const IconUser = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
      <path d="M2 13a6 6 0 0 1 12 0v1H2v-1z" />
    </svg>
  );

  const IconPlus = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2z" />
    </svg>
  );

  const IconPen = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M12.146 2.146a.5.5 0 0 1 .708 0l1.5 1.5a.5.5 0 0 1 0 .708l-9 9a.5.5 0 0 1-.39.15H2.5a.5.5 0 0 1-.5-.5v-2.464a.5.5 0 0 1 .15-.39l9-9z" />
    </svg>
  );

  const IconTrash = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
      <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1z" />
    </svg>
  );

  const IconTrophy = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-.5L12 13H4L2.5 8H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1V2z" />
    </svg>
  );

  const IconCheck = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M13.854 3.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 9.793l6.646-6.647a.5.5 0 0 1 .708 0z" />
    </svg>
  );

  const IconExcel = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path d="M14 2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12z" />
      <path d="M5.5 7.5L8 10l2.5-2.5" />
    </svg>
  );

  const exportToCSV = () => {
    if (!incentives.length) {
      alert("No data to export");
      return;
    }

    const headers = [
      "Employee",
      "Employee ID",
      "Type",
      "Description",
      "ForPeriod",
      "Amount",
      "Period",
      "Status",
      "Tax",
      "Notes",
    ];

    const csvRows = incentives.map((v) => [
      `"${v.EmployeeName}"`,
      `"${v.EmpId}"`,
      `"${v.IncentiveTypeName}"`,
      `"${v.Description}"`,
      `"${v.ForPeriod}"`,
      v.Amount,
      `"${v.PaidAmount || ""}"`,
      `"${v.IncentiveStatusName}"`,
      `"${v.TaxTreatment}"`,
      `"${v.Notes || ""}"`,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...csvRows].map((e) => e.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "incentives_data.csv";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="container-fluid">
      {/* Main Content */}
      <div>
        {/* Topbar */}
        <div className="form-head d-flex flex-wrap align-items-center page-head mb-0">
          <div className="me-auto">
            <h2 className="font-w600 mb-0">Incentive &amp; Bonus Management</h2>
            <p>
              {" "}
              Variable pay, performance incentives, retention and statutory
              bonuses. Open/partial records flow into payroll Step 5.
            </p>
          </div>
          <div className="rightside-tabs">
            <div className="topbar-actions flex items-center gap-2">
              <button
                className="bbtn-og btn-og-secondary btn-og-sm"
                onClick={exportToCSV}
              >
                <i className="fa-solid fa-file-excel"></i> Export
              </button>
              <button
                onClick={openAdd}
                className="btn-og theme-color btn-og-sm"
              >
                Add Incentive
              </button>
            </div>
          </div>
        </div>

        {/* Page Content */}
        <div className="page-content flex-1 overflow-auto p-6">
          {/* Summary Cards */}
          <div className="incentives-summary">
            <div className="blocks">
              <div className="block-div1">Open Records</div>
              <div className="block-div2">
                {incentiveManagementSummery?.OpenRecords || 0}
              </div>
            </div>
            <div className="blocks">
              <div className="block-div1">Total Incentive Pool</div>
              <div className="block-div2">
                {rup(incentiveManagementSummery?.TotalIncentivePool || 0)}
              </div>
            </div>
            <div className="blocks">
              <div className="block-div1">Paid Out</div>
              <div className="block-div2">
                {rup(incentiveManagementSummery?.PaidOut || 0)}
              </div>
            </div>
            <div className="blocks">
              <div className="block-div1">Pending Payout</div>
              <div className="block-div2">
                {rup(incentiveManagementSummery?.PendingPayout || 0)}
              </div>
            </div>
          </div>

          {/* Table Card */}
          <div className="card bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-200">
            <div className="toolbar">
              <input
                type="text"
                className="form-control w-52"
                placeholder="Search employee…"
                style={{ width: "200px" }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />

              <div className="toolbar-sep" />

              <select
                className="form-select w-44"
                value={filterType}
                style={{ width: "160px" }}
                onChange={(e) => setFilterType(e.target.value)}
              >
                <option value="">All Types</option>
                {incentiveTypesList.map((type) => (
                  <option key={type.Id} value={type.Id}>
                    {type.Name}
                  </option>
                ))}
              </select>

              <select
                className="form-select w-40"
                value={filterStatus}
                style={{ width: "160px" }}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="">All Status</option>
                {incentiveStatusList.map((IncentiveStatusName) => (
                  <option key={IncentiveStatusName.Id} value={IncentiveStatusName.Id}>
                    {IncentiveStatusName.Name}
                  </option>
                ))}
              </select>

              <div className="flex-1" />

              <span className="text-sm text-gray-500">
                {totalRecords} records
              </span>
            </div>

            <div className="overflow-x-auto">
              <table className="mgmt-tbl w-full">
                <thead>
                  <tr>
                    <th>Employee</th>
                    <th>Type</th>
                    <th>Description</th>
                    <th className="tr">Amount</th>
                    <th>For Period</th>
                    <th>Tax</th>
                    <th style={{ textAlign: "center" }}>Status</th>
                    <th style={{ textAlign: "center" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {incentives.length === 0 ? (
                    <tr>
                      <td
                        colSpan="8"
                        className="text-center py-12 text-gray-500"
                      >
                        No records found
                      </td>
                    </tr>
                  ) : (
                    incentives.map((v) => {
                      const statusClass =
                        v.IncentiveStatusName === "Open"
                          ? "badge-pending"
                          : v.IncentiveStatusName === "Paid"
                            ? "badge-paid"
                            : "badge-locked";

                      return (
                        <tr key={v.Id}>
                          <td>
                            <span style={{ fontWeight: 600 }}>
                              {v.EmployeeName}
                            </span>
                            <br />
                            <code
                              style={{
                                fontSize: "10px",
                                color: "var(--brand)",
                              }}
                            >
                              {v.EmpId}
                            </code>
                          </td>
                          <td>
                            <span
                              className="badge badge-active"
                              style={{ fontSize: "10.5px" }}
                            >
                              {v.IncentiveTypeName}
                            </span>
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              color: "var(--text-muted)",
                            }}
                          >
                            {v.Notes}
                          </td>
                          <td className="tr" style={{ fontWeight: 700 }}>
                            {rup(v.Amount)}
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              color: "var(--text-muted)",
                            }}
                          >
                            {v.ForPeriod || "—"}
                          </td>
                          <td>
                            <span
                              style={{
                                fontSize: "11px",
                                color:
                                  v.TaxTreatment === "Taxable"
                                    ? "var(--danger)"
                                    : "var(--success)",
                              }}
                            >
                              {v.TaxTreatment}
                            </span>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <span className={`badge ${statusClass}`}>
                              {v.IncentiveStatusName}
                            </span>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div
                              style={{
                                display: "flex",
                                gap: "4px",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                className="btn btn-light btn-sm"
                                onClick={() => openEdit(v.Id)}
                                title="Edit"
                              >
                                <i className="fa-solid fa-pen"></i>
                              </button>
                              <button
                                className="btn btn-light btn-sm"
                                onClick={() => askDelete(v.Id)}
                                title="Delete"
                                style={{ color: "var(--danger)" }}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="3">PAGE TOTAL</td>
                    <td className="tr" style={{ fontWeight: 700 }}>
                      {rup(pageTotalAmount)}
                    </td>
                    <td colSpan="4">—</td>
                  </tr>
                </tfoot>
              </table>
            </div>
            <Paginator
              first={first}
              rows={rows}
              totalRecords={totalRecords}
              rowsPerPageOptions={[10, 20, 50, 100]}
              onPageChange={onPageChange}
              template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            />
          </div>
        </div>
      </div>

      {/* Add/Edit Modal */}
      {showModal && (
        <div className="mo open" onClick={closeModal}>
          <div className="mb" onClick={(e) => e.stopPropagation()}>
            <div className="mh">
              <div
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "8px",
                  background: "var(--brand-soft)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--brand)",
                }}
              >
                <IconTrophy style={{ fontSize: "13px" }} />
              </div>
              <h6 Id="formTitle" className="font-bold text-base">
                {editId ? "Edit Incentive" : "Add Incentive"}
              </h6>
              <button
                onClick={closeModal}
                style={{
                  marginLeft: "auto",
                  background: "none",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  color: "#888",
                }}
              >
                ×
              </button>
            </div>

            <div className="mbody">
              {formErrors.form && (
                <div
                  style={{
                    padding: "10px",
                    marginBottom: "12px",
                    background: "#fee2e2",
                    border: "1px solid var(--danger)",
                    borderRadius: "6px",
                    color: "var(--danger)",
                    fontSize: "13px",
                  }}
                >
                  {formErrors.form}
                </div>
              )}
              <div className="fsec">Employee &amp; Incentive Details</div>
              <div className="fg2">
                <div>
                  <label className="form-label">
                    Employee <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <select
                    className={`form-select w-100`}
                    name="EmployeeName"
                    value={formData.EmployeeName}
                    onChange={handleInputChange}
                    style={
                      formErrors.EmployeeName
                        ? { borderColor: "var(--danger)" }
                        : {}
                    }
                  >
                    <option value="">Select…</option>
                    {EmployeeList?.map((employee) => (
                      <option
                        key={employee.Id}
                        value={`${employee.FullName}|${employee.EmploymentId}`}
                      >
                        {employee.FullName} ({employee.EmploymentId})
                      </option>
                    ))}
                  </select>
                  {formErrors.EmployeeName && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.EmployeeName}
                    </small>
                  )}
                </div>

                <div>
                  <label className="form-label">
                    Incentive Type{" "}
                    <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <select
                    className={`form-select w-100`}
                    name="IncentiveTypeName"
                    value={formData.IncentiveTypeName}
                    onChange={handleInputChange}
                    style={
                      formErrors.IncentiveTypeName
                        ? { borderColor: "var(--danger)" }
                        : {}
                    }
                  >
                    <option value="">Select…</option>
                    {incentiveTypesList.map((type, index) => (
                      <option key={index} value={type.Name}>
                        {type.Name}
                      </option>
                    ))}
                  </select>
                  {formErrors.IncentiveTypeName && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.IncentiveTypeName}
                    </small>
                  )}
                </div>

                <div>
                  <label className="form-label">
                    Amount (₹) <span style={{ color: "var(--danger)" }}>*</span>
                  </label>
                  <input
                    type="number"
                    className={`form-control w-100`}
                    name="amount"
                    placeholder="0"
                    value={formData.amount}
                    onChange={handleInputChange}
                    style={
                      formErrors.amount ? { borderColor: "var(--danger)" } : {}
                    }
                  />
                  {formErrors.amount && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.amount}
                    </small>
                  )}
                </div>

                <div>
                  <label className="form-label">For Period</label>
                  <select
                    className={`form-select w-100`}
                    name="ForPeriod"
                    value={formData.ForPeriod}
                    onChange={handleInputChange}
                    style={
                      formErrors.ForPeriod
                        ? { borderColor: "var(--danger)" }
                        : {}
                    }
                  >
                    <option value="">Select…</option>
                    {formonthList?.map((fm) => (
                      <option key={fm.Id} value={fm.Name}>
                        {fm.Name}
                      </option>
                    ))}
                  </select>
                  {formErrors.ForPeriod && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.ForPeriod}
                    </small>
                  )}
                </div>

                <div style={{ gridColumn: "1 / -1" }}>
                  <label className="form-label">Description</label>
                  <input
                    type="text"
                    className="form-control w-100"
                    name="Description"
                    placeholder="Brief description…"
                    value={formData.Description}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="fsec">Status &amp; Tax</div>
              <div className="fg2">
                <div>
                  <label className="form-label">Status</label>
                  <select
                    className={`form-select w-100`}
                    name="IncentiveStatusName"
                    value={formData.IncentiveStatusName}
                    onChange={handleInputChange}
                    style={
                      formErrors.IncentiveStatusName
                        ? { borderColor: "var(--danger)" }
                        : {}
                    }
                  >
                    {incentiveStatusList.map((status, index) => (
                      <option key={index} value={status.Name}>
                        {status.Name}
                      </option>
                    ))}
                  </select>
                  {formErrors.IncentiveStatusName && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.IncentiveStatusName}
                    </small>
                  )}
                </div>

                <div>
                  <label className="form-label">Tax Treatment</label>
                  <select
                    className={`form-select w-100`}
                    name="TaxTreatment"
                    value={formData.TaxTreatment}
                    onChange={handleInputChange}
                    style={
                      formErrors.TaxTreatment
                        ? { borderColor: "var(--danger)" }
                        : {}
                    }
                  >
                    <option>Taxable</option>
                    <option>Non-Taxable</option>
                  </select>
                  {formErrors.TaxTreatment && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.TaxTreatment}
                    </small>
                  )}
                </div>

                <div style={{ gridColumn: "1 / -1" }}>
                  <label className="form-label">Notes</label>
                  <textarea
                    className="form-control w-100"
                    name="Notes"
                    rows="2"
                    placeholder="Approval reference, criteria…"
                    value={formData.Notes}
                    onChange={handleInputChange}
                    style={
                      formErrors.Notes ? { borderColor: "var(--danger)" } : {}
                    }
                  />
                  {formErrors.Notes && (
                    <small
                      style={{
                        color: "var(--danger)",
                        display: "block",
                        marginTop: "4px",
                      }}
                    >
                      {formErrors.Notes}
                    </small>
                  )}
                </div>
              </div>
            </div>

            <div className="mfoot">
              <button className="btn btn-light" onClick={closeModal}>
                Cancel
              </button>
              <button className="btn btn-brand" onClick={saveIncentive}>
                <IconCheck />{" "}
                <span>{editId ? "Save Changes" : "Add Incentive"}</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="mo open" onClick={() => setShowDeleteModal(false)}>
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "400px",
              padding: "24px",
              boxShadow: "0 24px 64px rgba(0,0,0,.18)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "12px",
              }}
            >
              <div
                style={{
                  width: "34px",
                  height: "34px",
                  background: "#fee2e2",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--danger)",
                }}
              >
                <IconTrash />
              </div>
              <h6 style={{ margin: 0, fontWeight: 700 }}>Delete Incentive</h6>
            </div>
            <p
              style={{
                fontSize: "13px",
                color: "var(--text-mid)",
                margin: "0 0 18px",
              }}
            >
              Delete incentive record for{" "}
              {incentives.find((v) => v.Id === deleteId)?.EmployeeName}?
            </p>
            <div
              style={{
                display: "flex",
                gap: "8px",
                justifyContent: "flex-end",
              }}
            >
              <button
                className="btn btn-light"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn btn-brand"
                style={{
                  background: "var(--danger)",
                  borderColor: "var(--danger)",
                }}
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default IncentiveManagement;
